import * as React from "react";
import "./styles.scss";
import brandLogo from "../../assets/img/brv-logo-mark.png";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

const FooterBrand = () => (
  <div className="brand brand--inverse" aria-label="BR&V Technology Corp">
    <img src={brandLogo} alt="BR&V Technology Corp." />
    <span className="brandName">
      <strong>BR&V Technology</strong>
      <em>Corp</em>
    </span>
  </div>
);

const ContactItem = ({ icon: Icon, children }) => (
  <div className="contactItem">
    <Icon fontSize="inherit" aria-hidden="true" />
    <div className="contactItem__text">{children}</div>
  </div>
);

const Footer = () => {
  return (
    <footer id="footer">
      <div className="shell footer__grid">
        <div>
          <FooterBrand />
          <p>Empowering businesses with smart technology and digital solutions.</p>
        </div>

        <div>
          <h3>Solutions</h3>
          <a href="/konektav-lite-pos">KonekTaV Suite</a>
          <a href="/konektav-lite-pos">Lite-POS</a>
          <a href="/waka-payroll">Waka Payroll</a>
          <a href="/agrisense-mobile">Agrisense</a>
          <a href="/#solutions">IT Consultancy</a>
        </div>

        <div>
          <h3>Company</h3>
          <a href="/#about-us">About Us</a>
          <a href="/#why-brandv">Why BR&V</a>
          <a href="/#industries">Industries</a>
          <a href="/#contact">Contact</a>
        </div>

        <div>
          <h3>Policies</h3>
          <a href="/terms-and-conditions">Terms and Conditions</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/return-and-refund-policy">Return and Refund Policy</a>
          <a href="/dispute-resolution-policy">Dispute Resolution Policy</a>
        </div>

        <div id="contactUs">
          <h3>Customer Service</h3>
          <ContactItem icon={EmailOutlinedIcon}>
            <a href="mailto:contact@brvtechnologysg.com">contact@brvtechnologysg.com</a>
          </ContactItem>
          <ContactItem icon={PhoneOutlinedIcon}>
            <a href="tel:+639940908740">+63 994 090 8740</a>
          </ContactItem>
          <ContactItem icon={LocationOnOutlinedIcon}>
            <address>Lot 27 Blk 17, Canon St., Town and Country Cambridge, Brgy. Zone 15, Talisay City, Negros Occidental 6115, Philippines</address>
          </ContactItem>
          <ContactItem icon={BadgeOutlinedIcon}>SEC Registration No.: 2023090119006-01</ContactItem>
          <ContactItem icon={ReceiptLongOutlinedIcon}>BIR TIN: 649-694-887-00000</ContactItem>
          <ContactItem icon={AssignmentTurnedInOutlinedIcon}>Mayor's Permit No.: 2026-R-0001023</ContactItem>
        </div>
      </div>

      <div className="shell footer__bottom">
        <span>&copy; 2026 BR&V Technology Corp. All rights reserved.</span>
        <span>
          <a href="/privacy-policy">Privacy Policy</a>
          {" | "}
          <a href="/terms-and-conditions">Terms and Conditions</a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
